<ng-template ngIf="parcellaGiudiziale">
<div class="row">
	<ng-template [ngIf]="parcellaGiudiziale.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Cognome e nome'"
		[valueInput]="parcellaGiudiziale.legale?.legale.nominativo"></div>
	</ng-template>
	<ng-template [ngIf]="parcellaGiudiziale.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Ragione sociale'" [valueInput]="parcellaGiudiziale.legale?.legale.ragioneSociale"></div>
	</ng-template>
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Tipo legale'"
		[valueInput]="parcellaGiudiziale.legale?.categoriaLegaleIncaricato.descrizione"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Parcella'"
		[valueInput]="(parcellaGiudiziale?.numeroParcella ? 'Numero ' + parcellaGiudiziale.numeroParcella + ' del ' : '') + (parcellaGiudiziale?.dataParcella | date:'dd/MM/yyyy')">
	</div>
</div>
<div class="row">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Competenza'"
		[valueInput]="(parcellaGiudiziale.competenza)?parcellaGiudiziale.competenza?.descrizione:'Assistenza Giudiziale'"></div>
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Valore della causa'"
		[valueInput]="parcellaGiudiziale.scaglione?.label"></div>
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Valore'"
		[valueInput]="(parcellaGiudiziale.importoPetitumRiferimento  | euro) +' &euro;'"></div>
</div>

<div class="container_conteggi">
	<h5>
		<strong>Prospetto finale</strong>
	</h5>
	<div *ngFor="let speseGen of [( parcellaGiudiziale.spesa.percSpesaGenerale ? (parcellaGiudiziale.importoBase | percentage : parcellaGiudiziale.spesa.percSpesaGenerale) : 0  )]">
	<div *ngFor="let cassAvvocati of [( parcellaGiudiziale.flagCpa ?  (getSum(parcellaGiudiziale.importoBase , speseGen , parcellaGiudiziale.spesa.spesaTrasferta , parcellaGiudiziale.spesa.altraSpesaImponibile ) | percentage:parcellaGiudiziale.cpa.valore) : 0)]">
	<div *ngFor="let totaleImponibile of [(  getSum(parcellaGiudiziale.importoBase,speseGen,
									   ( parcellaGiudiziale.spesa ? parcellaGiudiziale.spesa.spesaTrasferta : 0),
									   ( parcellaGiudiziale.spesa ? parcellaGiudiziale.spesa.altraSpesaImponibile : 0),cassAvvocati )	)]">

	<div *ngFor="let iva of [( parcellaGiudiziale.flagIva ?  (totaleImponibile | percentage:parcellaGiudiziale.iva.valore) : 0)]">
	<div *ngFor="let ipotesiCompenso of [(  getSum(totaleImponibile , iva , parcellaGiudiziale.spesa?.spesaEsente)  )]">
	<div *ngFor="let ritenutaAcconto of [( parcellaGiudiziale.flagCpa ?  (  getSum(parcellaGiudiziale.importoBase,speseGen, ( parcellaGiudiziale.spesa ? parcellaGiudiziale.spesa.spesaTrasferta : 0),  ( parcellaGiudiziale.spesa ? parcellaGiudiziale.spesa.altraSpesaImponibile : 0)	)| percentage:20) : 0)]">
	<div *ngFor="let ritenutaAccontoSFlag of [( (!parcellaGiudiziale.flagCpa) ?  (totaleImponibile  | percentage:20):0)]">

								<div labelTextInput [labelInput]="'Compenso tabellare ex Art. 4, comma 5'"
									[typeLabel]="'conteggioProspetto'"
									[valueInput]="parcellaGiudiziale.importoBase"></div>
								<div *ngIf="speseGen"
									labelTextInput [labelInput]="'Descrizione altre spese e oneri ('+parcellaGiudiziale.spesa.percSpesaGenerale+'% sul compenso totale)'"
									[typeLabel]="'conteggioProspetto'" [valueInput]="speseGen.replace(',','.')"></div>

								<div *ngIf="parcellaGiudiziale.spesa.spesaTrasferta > 0"
								    labelTextInput [labelInput]="'Spese di trasferta'"
									[typeLabel]="'conteggioProspetto'"
									[valueInput]="parcellaGiudiziale.spesa?.spesaTrasferta"></div>

								<div *ngIf="parcellaGiudiziale.spesa.altraSpesaImponibile > 0"
									labelTextInput [labelInput]="'Altre spese imponibili non relative a trasferte'"
									[typeLabel]="'conteggioProspetto'"
									[valueInput]="parcellaGiudiziale.spesa?.altraSpesaImponibile"></div>

								<div *ngIf="parcellaGiudiziale.flagCpa"
									labelTextInput [labelInput]="'Cassa avvocati ('+parcellaGiudiziale.cpa.valore+'%)'"
									[typeLabel]="'conteggioProspetto'"
									[valueInput]="cassAvvocati.replace(',','.')"></div>

								<div labelTextInput [labelInput]="'Totale imponibile'"
									[typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleImponibile.replace(',','.')"></div>

								<div *ngIf="parcellaGiudiziale.flagIva"
									labelTextInput [labelInput]="'IVA '+parcellaGiudiziale.iva.valore+'% su imponibile'"
									[typeLabel]="'conteggioProspetto'" [valueInput]="iva.replace(',','.')"></div>

								<div *ngIf="parcellaGiudiziale.spesa.spesaEsente > 0"
									labelTextInput [labelInput]="'Spese esenti ex art. 15 DPR 633/72'"
									[typeLabel]="'conteggioProspetto'"
									[valueInput]="parcellaGiudiziale.spesa?.spesaEsente"></div>

								<div *ngIf="parcellaGiudiziale.contributoUnificato > 0"
									labelTextInput [labelInput]="'Contributo unificato'"
									[typeLabel]="'conteggioProspetto'"
									[valueInput]="parcellaGiudiziale.contributoUnificato"></div>

								<div
									labelTextInput [labelInput]="'Ipotesi di compenso liquidabile'"
									[typeLabel]="'conteggioProspettoBold'" [valueInput]="ipotesiCompenso.replace(',','.')"></div>

								<div *ngIf="parcellaGiudiziale.flagRitenutaAcconto  && parcellaGiudiziale.flagCpa" labelTextInput [labelInput]="'A dedurre ritenuta di acconto 20% (su compenso e spese imponibili)'"
									[typeLabel]="'conteggioProspetto'" [valueInput]="ritenutaAcconto.replace(',','.')"></div>

								<div *ngIf="parcellaGiudiziale.flagRitenutaAcconto  && !parcellaGiudiziale.flagCpa" labelTextInput [labelInput]="'A dedurre ritenuta di acconto 20% (su compenso e spese imponibili)'"
									[typeLabel]="'conteggioProspetto'" [valueInput]="ritenutaAccontoSFlag.replace(',','.')"></div>

								<div labelTextInput [labelInput]="'Totale documento'" [typeLabel]="'conteggioProspettoBold'"	[valueInput]="parcellaGiudiziale.importoParcella"></div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</div>
</ng-template>
